import { render } from "./emailComponent.vue?vue&type=template&id=2795e26e"
import script from "./emailComponent.vue?vue&type=script&lang=js"
export * from "./emailComponent.vue?vue&type=script&lang=js"

import "./emailComponent.vue?vue&type=style&index=0&id=2795e26e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__